import { render, staticRenderFns } from "./RestorePassForm.vue?vue&type=template&id=3d5f921a&"
import script from "./RestorePassForm.vue?vue&type=script&lang=js&"
export * from "./RestorePassForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports